/**
 * 设备绑定服务
 */
import apiClient from './api';
import { addUserDeviceID, removeUserDeviceID } from './auth';

/**
 * 统一处理响应
 */
const handleResponse = async (request) => {
  const response = await request;
  if (response.data.code === 0) {
    return response.data.data;
  }
  throw new Error(response.data.message || '请求失败');
};

/** 获取绑定列表 */
export const getBindings = async () => {
  return (await handleResponse(apiClient.post('/devices/bindings'))) || [];
};

/** 绑定设备 */
export const bindDeviceById = async (deviceId) => {
  await handleResponse(apiClient.post('/devices/bind', { device_id: deviceId }));
  addUserDeviceID(deviceId);
  return { success: true };
};

/** 解绑设备 */
export const unbindDeviceById = async (deviceId) => {
  await handleResponse(apiClient.post('/devices/unbind', { device_id: deviceId }));
  removeUserDeviceID(deviceId);
  return { success: true };
};
